export const SITE_TITLE = 'Auto1 Tech Blog'
